import Axios from "./axios";

const endpoint = "/api/rebar";
export default {
  //현장 자재목록 전체 조회
  //{"constructionId": 0}
  rebarList: (data) => Axios.post(`${endpoint}/list`, data),

  /**
   * 철근 종류 리스트
   */
  standardRebarList: () => Axios.post(`${endpoint}-standard/list`),
};
